/* istanbul ignore next */
export const reducer1 = () => { }